import React, { forwardRef, Ref } from 'react';
import getClassNames from '../../utils/getClassNames';

import Icon from '../Icon';

import styles from './DatepickerInput.module.scss';

export type DatepickerInputProps = {
  id?: string;
  value?: string;
  onChange?: () => void;
  onClick?: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
};

/**
 * forwardRef is required here to allow correct portal positioning when rendering
 * As we use the withPortal variant in our mobile implementation this is required
 * Documented here: https://reactdatepicker.com/#example-custom-input
 */
const DatepickerInput = forwardRef(({
  id,
  value,
  onChange,
  onClick, // Opens the popper
  placeholder,
  className,
  disabled,
}: DatepickerInputProps, ref: Ref<HTMLInputElement>) => (
  <div className={getClassNames(styles, 'root', className)}>
    <div className={styles.inputContainer}>
      {/* label, which wraps the control, is correctly associated with the input */}
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        htmlFor={id}
        className={styles.label}
      >
        <Icon
          id="common/calendar"
          className={styles.icon}
        />
        <input
          readOnly
          id={id}
          name={id}
          ref={ref}
          value={value}
          className={styles.input}
          onChange={onChange}
          onClick={onClick}
          placeholder={placeholder}
          disabled={disabled}
        />
      </label>
    </div>

  </div>
));

export default DatepickerInput;
